//dev avec PHP
//export const API_URL = "http://loyersws/api/";
//prod OVH
export const API_URL = "https://test.gestion.locabel.ovh/api/";

export const RENT_STATUS_PAID = "PAID";
export const RENT_STATUS_UNPAID = "UNPAID";
